import { Crown } from "lucide-react";
import { Badge } from "@b2b/ui-components";

export interface Plan {
  id: string;
  name: string;
  price: number;
  currency: string;
  billingCycle: "monthly" | "yearly";
  features: string[];
  status: "active" | "inactive";
  isRecommended?: boolean;
}

export const initialPlans: Plan[] = [
  {
    id: "1",
    name: "Basic",
    price: 29,
    currency: "USD",
    billingCycle: "monthly",
    features: [
      "Up to 10 product listings",
      "Basic analytics",
      "Email support",
      "Standard marketplace access",
      "Mobile app access",
    ],
    status: "active",
  },
  {
    id: "2",
    name: "Standard",
    price: 59,
    currency: "USD",
    billingCycle: "monthly",
    features: [
      "Up to 50 product listings",
      "Advanced analytics",
      "Priority email support",
      "Enhanced marketplace visibility",
      "API access",
      "Bulk import tools",
    ],
    status: "active",
  },
  {
    id: "3",
    name: "Professional",
    price: 99,
    currency: "USD",
    billingCycle: "monthly",
    features: [
      "Unlimited product listings",
      "Real-time analytics dashboard",
      "24/7 phone & email support",
      "Premium marketplace placement",
      "Full API access",
      "Advanced bulk tools",
      "Custom branding options",
      "Dedicated account manager",
    ],
    status: "active",
    isRecommended: true,
  },
  {
    id: "4",
    name: "Enterprise",
    price: 199,
    currency: "USD",
    billingCycle: "monthly",
    features: [
      "Everything in Professional",
      "White-label solutions",
      "Custom integrations",
      "On-premise deployment option",
      "24/7 dedicated support team",
      "Custom SLA agreements",
      "Advanced security features",
    ],
    status: "active",
  },
];

export const membershipTableConfig = {
  columns: [
    { key: "name", label: "Plan Name" },
    { key: "price", label: "Price" },
    { key: "billingCycle", label: "Billing" },
    { key: "features", label: "Features" },
    { key: "status", label: "Status" },
    { key: "actions", label: "Actions", align: "right" as const }, // ✅ fix
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      active: { background: "bg-green-100", textColor: "text-green-700" },
      inactive: { background: "bg-red-100", textColor: "text-red-700" },
    },
  },
};
